import React from 'react';
import PropTypes from 'prop-types';
import { formatText } from '../../../../utils/shared/formatUtils';
import Button from '../../../../components/button/Button';
import { ICON } from '../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

export const getQuestion = (questions, questionId) =>
    questions.find(question => question.item_id === questionId);

export const getQuestionText = question => question.stimulus.text;

const TQVMProbeDetails = ({ result, content: { questions, correctResponses } }) => (
    <div className="tqvm">
        {result.responses.map(({ item_id: questionId, response_id: responseId }) => {
            const question = getQuestion(questions, questionId);
            const { possible_responses: possibleResponses } = question;

            return (
                <div key={generateReactKey(questionId)} className="assessment-row space-between">
                    <span className="question-text">
                        {formatText(getQuestionText(question), {
                            delimiter: '%',
                            elementToWrap: 'span',
                            className: 'underline',
                        })}
                    </span>
                    <div className="answer-container space-between">
                        {possibleResponses.map(({ id, text }) => (
                            <div key={generateReactKey(id)} className="answer">
                                {correctResponses[questionId] === id && ICON.DONE}
                                <Button
                                    className={`btn ${id === responseId ? '' : 'not-selected'}`}
                                    text={text}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            );
        })}
    </div>
);

TQVMProbeDetails.propTypes = {
    result: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
};

export default TQVMProbeDetails;
